import dayjs from "dayjs";
import ApiCall from "utils/ApiCall";
import { getBookingByBookingNumber } from "./bookings";
import { getPrearrivalsBooking } from "./prearrivals";

// const route = `${process.env.REACT_APP_API}/api/users`;

const getPayments = async (query?: string) => {
  try {
    const route = `${
      process.env.REACT_APP_API
    }/payments/records?paymentType=S&filter=${JSON.stringify(query) || ""}`;
    const response = (await ApiCall.get(route)) || [];
    const bookings = await Promise.all(
      response.map(async (Payment: any) =>
        getBookingByBookingNumber(Payment.bookingNumber)
      )
    );

    const Payments = response
      .map((Payment: any) => {
        const booking = bookings.find(
          (booking) => booking.confirmationNumber === Payment.bookingNumber
        );
        return {
          ...Payment,
          ...booking,
          fullName: `${booking?.profile?.lastName || ""} ${
            booking?.profile?.firstName || ""
          }`,
          booking: booking || null,
          email: booking?.profile?.email?.email,
          phoneNumber: booking?.profile?.phoneNumber?.number,
        };
      })
      .filter((Payment: any) => Payment.booking)
      .sort(
        (a: any, b: any) =>
          dayjs(b.checkOutDate).toDate().getTime() -
          dayjs(a.checkOutDate).toDate().getTime()
      );

    return Payments || [];
  } catch (err) {
    return [];
  }
};

const getPreAuths = async (query?: string) => {
  try {
    const route = `${
      process.env.REACT_APP_API
    }/payments/records?paymentType=A&filter=${JSON.stringify(query) || ""}`;
    const response = (await ApiCall.get(route)) || [];
    const bookings = await Promise.all(
      response.map(async (preAuth: any) =>
        getBookingByBookingNumber(preAuth.bookingNumber)
      )
    );

    const preAuths = response
      .map((preAuth: any) => {
        const booking = bookings.find(
          (booking) => booking.confirmationNumber === preAuth.bookingNumber
        );
        return {
          ...preAuth,
          ...booking,
          fullName: `${booking?.profile?.lastName || ""} ${
            booking?.profile?.firstName || ""
          }`,
          booking: booking || null,
          email: booking?.profile?.email?.email,
          phoneNumber: booking?.profile?.phoneNumber?.number,
        };
      })
      .filter((preAuth: any) => preAuth.booking)
      .sort(
        (a: any, b: any) =>
          dayjs(b.checkOutDate).toDate().getTime() -
          dayjs(a.checkOutDate).toDate().getTime()
      );

    return preAuths || [];
  } catch (err) {
    return [];
  }
};

const preAuthComp = async (data: any) => {
  try {
    // console.log("preauthcomp", { data })

    return await ApiCall.post(
      `${process.env.REACT_APP_API}/payments/preauth/comp`,
      { ...data }
    );
  } catch (err) {
    console.error("preAuthComp err:", err);
    throw err;
  }
};

const settlePayment = async (data: any) => {
  try {
    const { selectedRecords } = data;

    return await ApiCall.post(
      `${process.env.REACT_APP_API}/hotel-notifications/settlement-report`,
      { paymentRecords: selectedRecords }
    );
  } catch (err) {
    console.error("settlePayment err:", err);
    throw err;
  }
};

const voidPayment = async (data: any) => {
  try {
    const { deviceId, id, selectedRecords, voidSingle } = data;
    console.log(data);

    if (voidSingle || selectedRecords.length === 0) {
      return await ApiCall.post(`${process.env.REACT_APP_API}/payments/void`, {
        id,
      });
    } else {
      await Promise.all(
        selectedRecords.map(async (item: any) => {
          return ApiCall.post(`${process.env.REACT_APP_API}/payments/void`, {
            deviceId,
            bookingNumber: item.bookingNumber,
          });
        })
      );
    }
  } catch (err) {
    console.error("PaymentComp err:", err);
    throw err;
  }
};

export { getPayments, voidPayment, preAuthComp, getPreAuths, settlePayment };
